import { render, staticRenderFns } from "./WalletHistoryDetails.vue?vue&type=template&id=219fb234&"
import script from "./WalletHistoryDetails.vue?vue&type=script&lang=js&"
export * from "./WalletHistoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports